import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import logo from '../logo.png';
import {
    Switch,
    Route,
    HashRouter
} from 'react-router-dom';
import { Col, Container, Row, Image } from 'react-bootstrap';
import Home from '../pages/Home';
import Games from '../pages/Games';
import About from '../pages/About';
import News from '../pages/News';
import { newsList } from '../data/news/NewsList';
import Jams from '../pages/Jams';

function Navigation() {
    return <HashRouter basename={process.env.PUBLIC_URL}>
        <Navbar variant="dark" expand="md" sticky={'top'}>
            <Container>
                <Navbar.Brand href="#home">
                    <Container fluid>
                        <Row>
                            <Col><Image alt="space castle games logo" src={logo} width="60" height="100" /></Col>
                        </Row>
                    </Container>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav>
                        <Nav.Link href="/">Home</Nav.Link>
                        <Nav.Link href="#/jams">Jams</Nav.Link>
                        <Nav.Link href="#/about">About</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar >

        <Switch>
            {routes}
        </Switch>
    </HashRouter >

}

/*
<Nav.Link href="/news">News</Nav.Link>
                    <Nav.Link href="/games">Games</Nav.Link>
*/

export default Navigation;

/* Rounting the routes! */
const routes = [
    <Route exact path="/games" component={Games} />
    , <Route exact path="/about" component={About} />
    , <Route exact path="/news" component={News} />
    , <Route exact path="/jams" component={Jams} />
    , <Route exact path="/" component={Home} />
];

AddToRoute();

function AddToRoute() {
    newsList.map((value, index) => {
        if (value.isPublished) routes.push(<Route key={index} exact path={value.path} component={value.component} />);
    });
    routes.push(<Route component={NotFound} />);
}

//Displays Not Found page is nothing else matches the path in navigation.
function NotFound() {
    return <Container className="page-container p-4" style={{ height: "100px" }}>
        <Row><Col><p>The page you are looking for does not exist.<br />For suppport please contact <a target="_blank" href="mailto:spacecastlegames@gmail.com">spacecastlegames@gmail.com</a></p></Col></Row>
    </Container>
}